import { DocumentStoreMutations } from "@/constants/store/document/documentStoreConstants";
import { SiteDocument } from "@/dataModel";
import { DocumentState } from "@/typings/store/states/DocumentStoreState";

export default {
  [DocumentStoreMutations.SET_SELECTED_DOCUMENT](state: DocumentState, document: SiteDocument) {
    state.document = document;
  },
};
